/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Messages_Askquestion_Successtoast3Inputs */

const en_coinvestments_messages_askquestion_successtoast3 = /** @type {(inputs: Coinvestments_Messages_Askquestion_Successtoast3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your question has been sent to the team`)
};

/**
* | output |
* | --- |
* | "Your question has been sent to the team" |
*
* @param {Coinvestments_Messages_Askquestion_Successtoast3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_messages_askquestion_successtoast3 = /** @type {((inputs?: Coinvestments_Messages_Askquestion_Successtoast3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Messages_Askquestion_Successtoast3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_messages_askquestion_successtoast3(inputs)
});
export { coinvestments_messages_askquestion_successtoast3 as "coInvestments_messages_askQuestion_successToast" }